import type { RouteRecordRaw } from 'vue-router'

import authRoutes from './auth'
import goalRoutes from './goal'
import projectRoutes from './project'
import portfolioRoutes from './portfolio'
import requirementRoutes from './requirement'
import productRoutes from './product'
import incidentRoutes from './incident'
import incidentH5Routes from './incidentH5'
import weeklyReportH5Routes from './weeklyReportH5'
import adminRoutes from './admin'
import userRoutes from './user'
import efficiencyRoutes from './efficiency'
import feedbackRoutes from './feedback'
import virtualEmployeeRoutes from './virtualEmployee'
import collectRoutes from './collect'
import workspaceRoutes from './workspace'

const userLayoutRoutes: RouteRecordRaw = {
  path: '/',
  component: () => import('@/layouts/UserLayout.vue'),
  children: [
    ...workspaceRoutes,
    ...goalRoutes,
    ...projectRoutes,
    ...portfolioRoutes,
    ...requirementRoutes,
    ...productRoutes,
    ...incidentRoutes,
    ...virtualEmployeeRoutes,
    ...efficiencyRoutes,
    ...feedbackRoutes,
    ...collectRoutes,
    ...userRoutes
  ]
}

const errorRoutes: RouteRecordRaw[] = [
  {
    path: '/403',
    name: 'Forbidden',
    component: () => import('@/views/error/Forbidden.vue'),
    meta: { title: '无权访问' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/NotFound.vue'),
    meta: { title: '页面未找到' }
  }
]

const routes: RouteRecordRaw[] = [
  ...authRoutes,
  ...incidentH5Routes,
  ...weeklyReportH5Routes,
  userLayoutRoutes,
  ...adminRoutes,
  ...errorRoutes
]

export default routes
